import { AnchorButton } from '@/common/helios/AnchorButton';
import {
  HowToFindSection,
  List,
  ListItem
} from '@/ev-tax-credit/HowToFind/HowToFind.styles';
import generateEvTaxCreditLink from '@/ev-tax-credit/utils/generateEvTaxCreditLink';

export default function HowToFind() {
  return (
    <div className="w-full bg-canvas-muted">
      <HowToFindSection>
        <h2 className="t-heading-2xl sm:t-heading-3xl md:t-heading-2xl">
          How to find eligible EV Tax Credit vehicles on our site
        </h2>
        <div className="md:row-span-2">
          <img
            src={`${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/ev_tax_credit_phone.png`}
            alt="A person using Carvana.com on their phone to search for vehicles that are eligible for the EV tax credit"
            className="rounded-2xl"
          />
        </div>
        <div className="grid w-full gap-4xl">
          <List>
            <ListItem>
              Find the “Great Deals” filter on your Search page
            </ListItem>
            <ListItem>Select EV Tax Credit and apply filters</ListItem>
            <ListItem>
              Look for the EV Credit badge on eligible vehicles
            </ListItem>
          </List>
          <AnchorButton
            href={generateEvTaxCreditLink()}
            size="lg"
            className="w-full sm:w-fit"
            data-analytics-id="How To Find - Shop Eligible Vehicles"
          >
            Shop Eligible Electric Vehicles
          </AnchorButton>
        </div>
      </HowToFindSection>
    </div>
  );
}
